<template>
  <div :class="containerClass" v-bind="$attrs">
    <!-- icon -->
    <div v-if="$slots.icon || icon" class="flex-shrink-0">
      <slot name="icon">
        <UIcon v-if="icon" :name="icon" class="text-xl" />
      </slot>
    </div>
    <!-- body -->
    <div class="flex-1 flex flex-col gap-1 min-w-0">
      <div v-if="title || $slots.title" :class="titleClass">
        <slot name="title" :title="title">{{ title }}</slot>
      </div>
      <div v-if="description || $slots.description" :class="descriptionClass">
        <slot name="description" :description="description">
          {{ description }}
        </slot>
      </div>
    </div>
    <!-- actions -->
    <div v-if="actions?.length" class="flex-shrink-0 flex flex-wrap gap-2 mt-1">
      <button
        v-for="(action, i) in actions"
        :key="i"
        type="button"
        class="bg-white text-pink-600 rounded-full px-6 py-2 text-sm font-medium hover:bg-pink-50 cursor-pointer border-0"
        @click="action.click"
      >
        {{ action.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
  defineOptions({ inheritAttrs: false })

  const props = defineProps({
    color: { type: String, default: "primary" },
    title: { type: String },
    description: { type: String },
    icon: { type: String },
    actions: { type: Array, default: () => [] },
  })

  const isRed = computed(() => props.color === "red")

  const containerClass = computed(() => {
    if (isRed.value) {
      return "rounded-lg p-4 flex items-start gap-3 bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400"
    }
    return "bg-pink-500 rounded-lg p-4 flex items-start gap-3 text-white"
  })

  const titleClass = computed(() => {
    if (isRed.value) return "font-semibold"
    return "font-bold text-lg"
  })

  const descriptionClass = computed(() => {
    if (isRed.value) return "text-sm"
    return "text-lg"
  })
</script>
